import React, { useEffect, useState, useLayoutEffect } from 'react'
import styled from 'styled-components'
import { TrootState, useAppDispatch, useAppSelector } from '../../app/store'

import { popUpState, TpopUpTypes } from './types'
import { setLogEvent } from './popUpSlice'

import CloseIcon from '../../assets/icons/closeIcon.png'


interface logEvent extends popUpState {
  timeOut: ReturnType<typeof setTimeout>
}

export default function PopUp() {
  const [logs, setLog] = useState<logEvent[]>([])
  const [cleanLog, setCleanLog] = useState<number|undefined>(undefined)
  const logEvents = useAppSelector((state: TrootState) => state.popUp)
  const timeOut = 5000;

  // LOADING LOG EVENT FROM REDUX
  useEffect(() => {
    const newLog = { ...logEvents }

    if (newLog.message !== undefined) {
      setLog([...logs, {
        ...newLog,
        timeOut: setTimeout(() => {
          if (newLog.timestamp)
          removeLog(newLog.timestamp)
        }, timeOut),
      }])
    }

  }, [logEvents])

  // REMOVING OLD LOGS
  function removeLog(logId: number) {
    setLog((state) => {
      const findLog = state.findIndex((item) => item.timestamp === logId)

      if (findLog > -1) {
        state.splice(findLog, 1)
        return [...state]
      }
      else return state
    })
  }

  useEffect(() => {
    const logToRemove = cleanLog

    if (logToRemove) {
      setLog((state) => {
        const findLog = state.findIndex((item) => item.timestamp === logToRemove)

        if (findLog > -1) {
          state.splice(findLog, 1)
          return [...state]
        }
        else return state
      })
    }
  }, [cleanLog])

  return(
    <PopUpContainer>
      { logs.map((log, index) => (
          <Notification
            key={`popup-log-${index}`}
            notificationType={log.type ? log.type : 'error'}
          >

            { log.message }

            <CloseContainer
              onClick={() => log.timestamp && removeLog(log.timestamp)}
            >
              <CloseImg src={CloseIcon}/>
            </CloseContainer>

          </Notification>
        ))
      }
    </PopUpContainer>
  )
}

const PopUpContainer = styled.div`
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 1001;
`

interface Tnotification { notificationType: TpopUpTypes }
const Notification = styled.div<Tnotification>`
  background-color: red;
  width: 500px;
  min-height: 30px;
  color: white;
  font-family: Montserrat;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  padding-left: 15px;
  border-radius: 5px;
  margin-top: 10px; 
  box-shadow: 5px 5px 15px black;
  ${(args) => args.notificationType === 'info' && `
    background-color: #B8006B;
  `}
`

  const CloseContainer = styled.div`
    cursor: pointer;
  `
    const CloseImg = styled.img`
      width: 30px;
      cursor: pointer;
    `